'use strict';

import { EventEmitter } from "../util/eventemitter";

class _InputManager extends EventEmitter {
  constructor() {
    super();

    const addElCapture = (name: string, outname?: string) => {
      if (!outname) {
        outname = name;
      }
      $(() => {
        renderer.domElement.addEventListener(name, (e: Event) => {
          this._handleEvent(outname!, e);
        }, false);
      });
    };
    const addCapture = (name: string, outname?: string) => {
      if (!outname) {
        outname = name;
      }
      document.addEventListener(name, (e: Event) => {
        this._handleEvent(outname!, e);
      }, false);
    };

    addElCapture('mousedown');
    addCapture('mouseup');
    addCapture('mousemove');
    addCapture('keydown');
    addCapture('keyup');
    addElCapture('touchstart');
    addElCapture('touchend');
    addElCapture('touchmove');
    addElCapture('mousewheel');
    addElCapture('DOMMouseScroll', 'mousewheel');

    document.addEventListener('contextmenu', function(e: Event) {
      e.preventDefault();
    });
  }

  _handleEvent(name: string, e: Event) {
    this.emit(name, e);
  }
}

export const InputManager = new _InputManager();
